import { useEffect, useState } from 'react';

export default function useActivityStage(props) {

  const { subIndex, 
    setHidden, 
    setHighlight, 
    handleStageZero, 
    handleStageOne, 
    handleStageTwo, 
    handleStageThree,
    isInstruction } = props;

  const [stage, setStage] = useState(0); // controls example stage or activity stage for both assessment and default mode.

  /**
   * handle stages
   */
  useEffect(() => {
    onStageChange();
  }, [stage, subIndex, isInstruction]);

  /**
   * Handles Amira speech, update box highlight, update swapping animation.
   * At the end of the run, call close callback.
   */
  const onStageChange = async () => {
    if(isInstruction){
      return; // if the phrase component is currently giving instructions, our only job is to sit here and look pretty
    }
    
    setHiddenAfterDelay();
    setHighlightAfterDelay();

    const stageHandlers = {
      0: handleStageZero, // intro
      1: handleStageOne, // assessment or tutor or intervention mode stage one
      2: handleStageTwo, // pause, only for assessment mode
      3: handleStageThree, // end, only for assessment mode
    };

    const currentStageHandler = stageHandlers[stage];
    await currentStageHandler();
  };

  /**
   * Sets the hidden state to false after a delay.
   */
  const setHiddenAfterDelay = () => {
    setTimeout(() => {
      setHidden(false);
    }, 350);
  };
  
  /**
   * Sets the highlight state to null after a delay.
   */
  const setHighlightAfterDelay = () => {
    setTimeout(() => {
      setHighlight(null);
    }, 800);
  };

  return {
    stage,
    setStage,
  }
}